import React from 'react';
import '../Styles/Components/form-field.css';

const FormField = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  onBlur,
  error,
  placeholder,
  required = false,
  mask
}) => {
  const formatPhone = (value) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 2) return cleaned;
    if (cleaned.length <= 7) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
    if (cleaned.length <= 11) return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
    return cleaned;
  };

  const formatCPF = (value) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 6) return `${cleaned.slice(0, 3)}.${cleaned.slice(3)}`;
    if (cleaned.length <= 9) return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`;
    return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(9, 11)}`;
  };

  const handleChange = (e) => {
    let newValue = e.target.value;

    if (type === 'tel') {
      newValue = formatPhone(newValue);
    } else if (type === 'cpf') {
      newValue = formatCPF(newValue);
    }

    onChange({
      target: {
        name: e.target.name,
        value: newValue
      }
    });
  };

  return (
    <div className="form-field">
      <div className="form-field-wrapper">
        <input
          type={type === 'cpf' ? 'text' : type}
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          placeholder=" "
          required={required}
          className={`form-input ${error ? 'error' : ''} ${value ? 'has-value' : ''}`}
          id={name}
        />
        <label htmlFor={name} className="form-label">
          {label} {required && <span className="required">*</span>}
        </label>
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default FormField;